import {Observable} from '../../../../../node_modules/rxjs';
import {FileData} from '../file-data';

export abstract class AbstractEntityFileTypeService {

  public abstract getFile(entity, params?: any): Observable<FileData>
}
